import { Alignment } from "./Alignment";
import { Color } from "./Color";
import { Gradient } from "./Gradient";

export class LinearGradient extends Gradient {
  constructor(props: {
    begin?: Alignment;
    end?: Alignment;
    colors?: Color[];
    stops?: number[];
  }) {
    super();
  }
}
